import React, { useContext, useEffect } from 'react';
import { GlobalContext } from '../../reducers/global';
import getVal from '../../api/utils/getVal';
import dataSetUrls from '../../constants/dataSetUrls';
import getChild from '../../api/getChild';
import langs from '../../translations/langs';
import getGraph from '../../api/getGraph';



const DownloadPdf = ({ wct, wcd, wcs, text, type, id }) => {
    const {
        state: {
            child,
            measurements,
            options: { language, dataSet },
        },
        dispatch,
    } = useContext(GlobalContext);
    
    const { dataSets } = langs[language];
    const currentDataSetId = dataSets.filter((val) => val.name === dataSet)[0].id;
    const url = dataSetUrls[currentDataSetId];

    
    useEffect(() => {
        getChild(dataSetUrls[currentDataSetId], child, measurements.values).then((res) => {
            dispatch({
                type: 'GROWTHCHART_UPDATE',
                ...res,
            });
        });
    }, [child, measurements, dispatch, currentDataSetId]);

    useEffect(() => {
        getGraph(url, type, {
            wcd,
            wct,
            wcs,
        });
    }, [url, wcd, wct, wcs, type]);

    return (
      <a id={id} className="btn secondary downloadBtn" href={`${url}webcharts.com/report.pdf?wct=${getVal(wct)}&wcd=${getVal(wcd)}&wcs=${getVal(wcs)}`} target="_blank" rel="noopener noreferrer">
            {text}
        </a>
    );
};

export default DownloadPdf;
